export const styles: Record<string, React.CSSProperties> = {
  container: {
    width: "calc(100% - 32px)",
    padding: 16,
    borderRadius: 15,
    minHeight: 100,
  },
};
